export type MicrochipCompany = {
  id: string;
  name: string;
  phone?: string;
  website?: string;
};

export const MICROCHIP_COMPANIES: MicrochipCompany[] = [
  {
    id: 'homeagain',
    name: 'HomeAgain',
    phone: '1-888-466-3242',
    website: 'https://www.homeagain.com',
  },
  {
    id: 'akc',
    name: 'AKC Reunite',
    phone: '1-800-252-7894',
    website: 'https://www.akcreunite.org',
  },
  {
    id: 'petlink',
    name: 'PetLink',
    phone: '1-877-738-5465',
    website: 'https://www.petlink.net',
  },
  {
    id: 'twentyfourpetwatch',
    name: '24Petwatch',
    phone: '1-866-597-2424',
    website: 'https://www.24petwatch.com',
  },
  {
    id: 'avid',
    name: 'AVID',
    phone: '1-800-336-2843',
    website: 'https://www.avidid.com',
  },
  {
    id: 'smarttag',
    name: 'SmartTag',
    phone: '1-877-818-7387',
    website: 'https://www.idtag.com',
  },
];

const MICROCHIP_COMPANY_LOOKUP: Record<string, MicrochipCompany> = MICROCHIP_COMPANIES.reduce(
  (acc, company) => {
    acc[company.id] = company;
    return acc;
  },
  {} as Record<string, MicrochipCompany>
);

export function getMicrochipCompanyById(id?: string | null): MicrochipCompany | undefined {
  if (!id) {
    return undefined;
  }
  return MICROCHIP_COMPANY_LOOKUP[id];
}
